import type { FetchError } from "app/pages/sales-intelligence/types";

export const unknownToFetchError = (error: unknown): FetchError =>
    error instanceof Error ? error.message : error === undefined ? undefined : String(error);
